import { connect } from 'react-redux';
import DashboardAdminRecommendedUtilities from '../components/DashboardAdminRecommendedUtilities';
import storage from '../../../../../lib/Storage';

import { schema } from '../../../../../state/schema';
import {
  loadRecommendedUtilitiesAdmin,
  recommendedUtilityAdminShowForm,
  getRecommendedUtilityAdminDownloadURL,
  patchRecommendedUtilityAdmin,
  deleteRecommendedUtilityAdmin,
} from '../../../../../state/modules/recommendedUtilitiesAdmin/actions';
import { denormalize } from 'normalizr';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  const order = 'created_at.asc';
  const limit = 5;
  const page_recommended_utilities =
    parseInt(ownProps.page_recommended_utilities) ?? 1;

  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  const result = state.recommendedUtilitiesAdmin.getIn([
    'pages',
    partnershipId,
    order,
    limit,
    page_recommended_utilities,
  ]);

  return {
    page_recommended_utilities,
    order,
    limit,
    partnershipId,
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['recommendedUtilitiesAdmin', x]),
                schema.recommendedUtilityAdmin,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
      : [],
    isLoading:
      state.recommendedUtilitiesAdmin.get('isLoading') ||
      state.recommendedUtilitiesAdmin.get('isFileDownloading'),
    total: state.recommendedUtilitiesAdmin.get('total') ?? 0,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, page, limit, order, cb) => {
      dispatch(
        loadRecommendedUtilitiesAdmin(partnershipId, page, limit, order, cb)
      );
    },
    showForm: (recommendedUtilityId) => {
      dispatch(recommendedUtilityAdminShowForm(recommendedUtilityId));
    },
    download: (path, fileName, cb) => {
      dispatch(getRecommendedUtilityAdminDownloadURL(path, fileName, cb));
    },
    patch: (partnershipId, id, data, cb) => {
      dispatch(patchRecommendedUtilityAdmin(partnershipId, id, data, cb));
    },
    remove: (partnershipId, id, cb) => {
      dispatch(deleteRecommendedUtilityAdmin(partnershipId, id, cb));
    },
  };
};

const DashboardAdminRecommendedUtilitiesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardAdminRecommendedUtilities);

export default DashboardAdminRecommendedUtilitiesContainer;
